import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import { useSpotify } from './context/SpotifyContextContainer'

import Layout from './Layout/Layout'

export default function PrivateRoute({component: Component, ...rest}) {
    const {
        code,
        accessToken,
        refreshToken,
        user
    } = useSpotify()
    return (
        <Route
            {...rest}
            render={props => {
                return (accessToken, code, refreshToken) ? <Layout><Component {...props} /></Layout>: <Redirect to="/login"/>
            }}
        ></Route>
    )
}
